module.exports = __webpack_public_path__ + "static/media/view admitted studentss.25c6c7be.svg";